require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/cookies/cookies.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/cookies/cookies.legacy.js
// module id = 200
// module chunks = 32 38